/**
 * Login session persistence helpers (web + Capacitor shell).
 *
 * Native WebViews treat app kill as "browser close", so Django session cookies
 * with set_expiry(0) are wiped. Prefer a persistent session on native clients.
 */
import { isNativeAppShell, getNativePlatform } from './mobileView';

export const REMEMBER_ME_DEFAULT_NATIVE = true;
export const REMEMBER_ME_DEFAULT_WEB = false;

export function getDefaultRememberMe() {
  try {
    return isNativeAppShell() ? REMEMBER_ME_DEFAULT_NATIVE : REMEMBER_ME_DEFAULT_WEB;
  } catch {
    return REMEMBER_ME_DEFAULT_WEB;
  }
}

/** Header so the backend can force persistent sessions even if the form field is missing. */
export function getLoginClientHeaders() {
  const headers = {};
  try {
    if (isNativeAppShell()) {
      headers['X-RoomNexa-Client'] = 'capacitor';
      const platform = getNativePlatform();
      if (platform === 'ios' || platform === 'android') {
        headers['X-RoomNexa-Platform'] = platform;
      }
    }
  } catch {
    // ignore detection failures — login must still work
  }
  return headers;
}

/**
 * Attach remember_me to login FormData. Always sends an explicit 0/1 value.
 * @param {FormData} formData
 * @param {boolean} rememberMe
 */
export function appendRememberMe(formData, rememberMe) {
  if (!formData || typeof formData.append !== 'function') {
    return;
  }
  try {
    const persist = Boolean(rememberMe) || isNativeAppShell();
    formData.append('remember_me', persist ? '1' : '0');
  } catch {
    try {
      formData.append('remember_me', rememberMe ? '1' : '0');
    } catch {
      // FormData append should not fail; swallow to avoid blocking login
    }
  }
}

export function buildLoginRequestHeaders(csrfToken) {
  return {
    'X-CSRFToken': csrfToken || '',
    ...getLoginClientHeaders(),
  };
}
